// apiFetch — обёртка над fetch для same-origin запросов к бэкенду.
// credentials: "include" обязательно — session cookie ставится backend'ом.
//
// В dev: Vite proxy перенаправляет /api, /auth и пр. на http://127.0.0.1:8080.
// В prod: фронт раздаётся самим бэкендом → same-origin естественно.

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly body: unknown,
    message: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

export async function apiFetch<T = unknown>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
      ...init?.headers,
    },
    ...init,
  });

  // 204 No Content — пустое тело.
  if (res.status === 204) return undefined as T;

  const contentType = res.headers.get('content-type') ?? '';
  const isJSON = contentType.includes('application/json');
  const body: unknown = isJSON ? await res.json() : await res.text();

  if (!res.ok) {
    const msg =
      isJSON && typeof body === 'object' && body && 'error' in body
        ? String((body as { error: unknown }).error)
        : `HTTP ${res.status}`;
    throw new ApiError(res.status, body, msg);
  }
  return body as T;
}
